$(document).ready(() => {
  $('#attachment_location').fileinput({
    showPreview: false,
    showUpload: false
  });
  $('#save_attachment').click(() => {
    $('#save_attachment').addClass('disabled');
    $('#save_attachment').prop('value', 'Uploading...');
  });
});